//@flow

const emailValidator = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export function isEmailLegal(email: string): boolean {
  return emailValidator.test(String(email).toLowerCase());
}



// WEBPACK FOOTER //
// ./src/util/emailUtils.js